import { Avatar } from "@heroui/avatar";
import React from 'react';
import { User } from '@/types/models/user';

const NavbarUserProfile = ({ user }: { user: User | null }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div className="flex flex-col items-center justify-center">
        <Avatar
          name={user?.name}
          color={'primary'}
          className="w-20 h-20"
          classNames={{
            name: 'text-2xl uppercase',
          }}
          getInitials={(name) =>
            name
              .split(' ')
              .map((n) => n[0])
              .join('')
              .slice(0, 2)
          }
        />
        <span className="font-semibold text-[17px] text-gray-dark">
          {user?.name}
        </span>
        <span className="-mt-1 text-gray-light text-[13px]">{user?.email}</span>
      </div>
    </div>
  );
};

export default NavbarUserProfile;
